import styles from "./ProductPage.module.css";
import axios from 'axios';
import React,{ useState ,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import { BrandImgInfoBanner } from "../../commonComponents";
import { D2CSubscriptionBoxDetail } from "../../components";
import { facebookCAPI } from "../../utils/FacebookCAPI";
import Api from "../../utils/Api/Api";
import UTMTracker from "../../utils/UTMTracker";

export const ProductPage = ()=>{
    const [productData,setProductData] = useState({
        name:"",
        banner_img:"",
        logo:"",
        desc:"",
        plans:[],
        termNCond:[],
    });
    const products = [1,2,3,4,5,6]
    const [loading,setLoading] = useState(true);
    const [hasError,setError] = useState(false);
    const navigate = useNavigate();
    useEffect(()=>{
        const fetchBrandData = async ()=>{
            try {
                let { data: {vendor_data, plans_data } } = await axios.get("https://mocki.io/v1/6c440058-eb5e-4b7e-8cb4-a13cf1bd11ee");
                setProductData({
                    name:vendor_data.service.service_name,
                    banner_img: vendor_data.detail_page_banner_url,
                    logo:vendor_data.service.logo_url,
                    desc:vendor_data.description,
                    plans:plans_data,
                    termNCond:vendor_data.terms_and_conditions
                })
            }
            catch(err) {
                setError(true);
            }
            setLoading(false)
        }
        fetchBrandData();
    },[])
    useEffect(() => {
        UTMTracker.captureUTMParams();
    }, []);
    if(hasError) {
        return <ErrorFallback />
    }
    if(loading) {
        return <ProductPageSkeleton />
    }
    const handleBuyNow = async () => {
        try {
            console.log("Product page handleBuyNow called");
            
            // Track the event with Facebook Pixel
            window.fbq('track', 'InitiateCheckout', {
                content_type: 'product',
                content_ids: [productData.id || ''],
                content_name: productData.name,
                currency: 'INR',
                value: 500 // using the hardcoded value from the JSX
            });
            
            // Also track with CAPI
            const productDetails = {
                content_ids: [productData.id || ''],
                content_name: productData.name,
                currency: 'INR', 
                value: 500,
                original_price: 750, // from JSX
            };
            
            facebookCAPI.trackInitiateCheckout(productDetails, {}).catch(error => {
                console.error("Error tracking product checkout event:", error);
            });
            
            // Navigate to checkout or add to cart logic would go here
            // For now, let's just navigate to the checkout page
            navigate('/checkout');
            
        } catch (error) {
            console.error("Error in product handleBuyNow:", error);
        }
    };
    return(
        <div className={styles.productPage}>
            <BrandImgInfoBanner brandData={productData}/>
            <div className={styles.content}>
                <div className={styles.productBoxContainer}>
                    <p className={styles.title}>What it includes</p>
                    <div className={styles.boxesAndPrice}>
                        <div className={styles.boxes}>
                            {
                                products.map((ele,idx)=>(
                                    <D2CSubscriptionBoxDetail key={idx} />
                                ))
                            }
                        </div>
                        <div className={styles.priceInfo}>
                            <div className={styles.markedPriceContainer}>
                                <p>Worth</p>
                                <p className={styles.markedPrice}>₹ 750</p>
                            </div>
                            <div className={styles.actualPriceContainer}>
                                <p>Get at</p>
                                <p className={styles.actualPrice}>₹ 500</p>
                            </div>
                            <div className={styles.buyButton} onClick={handleBuyNow}>
                                BUY NOW
                            </div>                 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

// Skeleton loader for the ProductPage
const ProductPageSkeleton = () => {
  return (
    <div className={styles.productPage}>
      {/* Banner Skeleton */}
      <div className={styles.bannerSkeleton}>
        <div className={styles.bannerImageSkeleton}></div>
        <div className={styles.bannerContentSkeleton}>
          <div className={styles.logoSkeleton}></div>
          <div className={styles.productNameSkeleton}></div>
          <div className={styles.productDescSkeleton}></div>
        </div>
      </div>
      
      {/* Content Skeleton */}
      <div className={styles.content}>
        <div className={styles.productBoxContainer}>
          <div className={styles.titleSkeleton}></div>
          
          <div className={styles.boxesAndPrice}>
            <div className={styles.boxes}>
              {/* Product Box Skeletons */}
              {Array(6).fill(0).map((_, idx) => (
                <div key={idx} className={styles.productBoxSkeleton}>
                  <div className={styles.productBoxImageSkeleton}></div>
                  <div className={styles.productBoxDetailSkeleton}></div>
                </div>
              ))}
            </div>
            
            {/* Price Info Skeleton */}
            <div className={styles.priceInfoSkeleton}>
              <div className={styles.markedPriceSkeleton}></div>
              <div className={styles.actualPriceSkeleton}></div>
              <div className={styles.buyButtonSkeleton}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};